import React from 'react';
import MuiGrid from '@material-ui/core/Grid';

const Col = (props) => {
  return <MuiGrid item {...props} />;
};

export default Col;
